import {
  FaUserCircle,
  FaWallet,
  FaQuestionCircle,
  FaDice,
  FaEnvelope,
  FaUser,
  FaSignOutAlt,
  FaChartLine,
  FaHistory,
} from "react-icons/fa";

import { useTranslation } from "react-i18next";
import { parseJWT } from "../../utils/jwtUtils";
import { Link, useLocation } from "react-router-dom";
import sidebarBgImage from "../../assets/sidebar-4.jpg";

const ResponsiveMenu = ({ showMenu }) => {
  const { t: translate, i18n } = useTranslation(["header"]);
  const location = useLocation();

  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  const userInfo = parseJWT(token?.token);

  const handleLogout = () => {
    localStorage.removeItem("userInfo");
    window.location.href = "/login";
  };

  const menuItem =
    "flex items-center gap-3 py-2 px-3 rounded-lg transition hover:bg-cyan-700/30";

  const activeMenu = "bg-cyan-700/40";

  return (
    <>
      {/* SIDEBAR */}
      <div
        className={`${
          showMenu ? "translate-x-0" : "-translate-x-full"
        } fixed left-0 top-0 z-[100] h-screen w-[75%] min-w-[300px] text-white transition-transform duration-300 md:hidden`}
      >
        <div
          style={{
            backgroundImage: `linear-gradient(to bottom, rgba(106, 130, 251, 0.7), rgba(252, 92, 125, 0.7)), url(${sidebarBgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="flex flex-col justify-between h-full p-6 overflow-hidden"
        >
          {/* TOP CONTENT */}
          <div className="overflow-y-auto pr-1">
            {/* USER */}
            <div className="mb-6 flex items-center gap-3">
              <FaUserCircle size={48} className="text-cyan-400" />
              <div>
                <h1 className="font-semibold text-lg font-serif">
                  {userInfo?.username || "Player"}
                </h1>
                <h2 className="text-sm text-cyan-200 font-serif">
                  {userInfo?.phone}
                </h2>
              </div>
            </div>

            <nav className="flex flex-col gap-4">
              {/* ACCOUNT */}
              <div>
                <h3 className="text-xs tracking-widest text-cyan-300 uppercase mb-2">
                  Account
                </h3>
                <div className="h-[1px] bg-cyan-700 opacity-40 mb-2" />

                <ul className="flex flex-col gap-1">
                  <li>
                    <Link
                      to="/"
                      className={`${menuItem} ${
                        location.pathname === "/" ? activeMenu : ""
                      }`}
                    >
                      <FaDice className="text-cyan-400" />
                      {translate("home")}
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/profile"
                      className={`${menuItem} ${
                        location.pathname === "/profile" ? activeMenu : ""
                      }`}
                    >
                      <FaUser className="text-cyan-400" />
                      {translate("Profile")}
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/wallet"
                      className={`${menuItem} ${
                        location.pathname === "/wallet" ? activeMenu : ""
                      }`}
                    >
                      <FaWallet className="text-cyan-400" />
                      {translate("Wallet")}
                    </Link>
                  </li>
                </ul>
              </div>

              {/* STATISTICS */}
              <div>
                <h3 className="text-xs tracking-widest text-cyan-300 uppercase mb-2">
                  Statistics
                </h3>
                <div className="h-[1px] bg-cyan-700 opacity-40 mb-2" />

                <ul className="flex flex-col gap-1">
                  <li>
                    <Link
                      to="/referralIncome"
                      className={`${menuItem} ${
                        location.pathname === "/referralIncome"
                          ? activeMenu
                          : ""
                      }`}
                    >
                      <FaChartLine className="text-cyan-400" />
                      {translate("Referral_Income")}
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/history"
                      className={`${menuItem} ${
                        location.pathname === "/history" ? activeMenu : ""
                      }`}
                    >
                      <FaHistory className="text-cyan-400" />
                      {translate("Game_History")}
                    </Link>
                  </li>
                </ul>
              </div>

              {/* CONTACT */}
              <div>
                <h3 className="text-xs tracking-widest text-cyan-300 uppercase mb-2">
                  Contact
                </h3>
                <div className="h-[1px] bg-cyan-700 opacity-40 mb-1" />

                <ul className="flex flex-col">
                  <li>
                    <a
                      href="https://t.me/enatgames"
                      className={menuItem}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaEnvelope className="text-cyan-400" />
                      {translate("Contact_Us")}
                    </a>
                  </li>

                  <li>
                    <Link
                      to="/HowToPlay"
                      className={`${menuItem} ${
                        location.pathname === "/HowToPlay" ? activeMenu : ""
                      }`}
                    >
                      <FaQuestionCircle className="text-cyan-400" />
                      {translate("How_Play")}
                    </Link>
                  </li>
                </ul>
                {/* LOGOUT */}
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-3 px-3 rounded-lg hover:bg-red-600/30 transition"
                >
                  <FaSignOutAlt className="text-red-400" />
                  {translate("Log_out")}
                </button>
              </div>
            </nav>
          </div>

          {/* SOCIAL */}
          <div className="absolute grid grid-cols-1 md:grid-cols-2 gap-8 bottom-4">
            <div>
              <h4 class="text-white font-semibold text-base mb-3">Follow Us</h4>

              <ul class="flex flex-wrap gap-4">
                <li>
                  <a href="https://t.me/enatgames">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="fill-blue-600 w-7 h-7"
                      viewBox="0 0 49.652 49.652"
                    >
                      <path
                        d="M24.826 0C11.137 0 0 11.137 0 24.826c0 13.688 11.137 24.826 24.826 24.826 13.688 0 24.826-11.138 24.826-24.826C49.652 11.137 38.516 0 24.826 0zM31 25.7h-4.039v14.396h-5.985V25.7h-2.845v-5.088h2.845v-3.291c0-2.357 1.12-6.04 6.04-6.04l4.435.017v4.939h-3.219c-.524 0-1.269.262-1.269 1.386v2.99h4.56z"
                        data-original="#000000"
                      />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="https://t.me/enatgames">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-7 h-7"
                      viewBox="0 0 112.196 112.196"
                    >
                      <circle
                        cx="56.098"
                        cy="56.097"
                        r="56.098"
                        fill="#007ab9"
                        data-original="#007ab9"
                      />
                      <path
                        fill="#fff"
                        d="M89.616 60.611v23.128H76.207V62.161c0-5.418-1.936-9.118-6.791-9.118-3.705 0-5.906 2.491-6.878 4.903-.353.862-.444 2.059-.444 3.268v22.524h-13.41s.18-36.546 0-40.329h13.411v5.715c-.027.045-.065.089-.089.132h.089v-.132c1.782-2.742 4.96-6.662 12.085-6.662 8.822 0 15.436 5.764 15.436 18.149zm-54.96-36.642c-4.587 0-7.588 3.011-7.588 6.967 0 3.872 2.914 6.97 7.412 6.97h.087c4.677 0 7.585-3.098 7.585-6.97-.089-3.956-2.908-6.967-7.496-6.967zm-6.791 59.77H41.27v-40.33H27.865v40.33z"
                        data-original="#f1f2f2"
                      />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="https://t.me/enatgames">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-7 h-7"
                      viewBox="0 0 152 152"
                    >
                      <linearGradient
                        id="a"
                        x1="22.26"
                        x2="129.74"
                        y1="22.26"
                        y2="129.74"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" stop-color="#fae100" />
                        <stop offset=".15" stop-color="#fcb720" />
                        <stop offset=".3" stop-color="#ff7950" />
                        <stop offset=".5" stop-color="#ff1c74" />
                        <stop offset="1" stop-color="#6c1cd1" />
                      </linearGradient>
                      <g data-name="Layer 2">
                        <g data-name="03.Instagram">
                          <rect
                            width="152"
                            height="152"
                            fill="url(#a)"
                            data-original="url(#a)"
                            rx="76"
                          />
                          <g fill="#fff">
                            <path
                              fill="#ffffff10"
                              d="M133.2 26c-11.08 20.34-26.75 41.32-46.33 60.9S46.31 122.12 26 133.2q-1.91-1.66-3.71-3.46A76 76 0 1 1 129.74 22.26q1.8 1.8 3.46 3.74z"
                              data-original="#ffffff10"
                            />
                            <path
                              d="M94 36H58a22 22 0 0 0-22 22v36a22 22 0 0 0 22 22h36a22 22 0 0 0 22-22V58a22 22 0 0 0-22-22zm15 54.84A18.16 18.16 0 0 1 90.84 109H61.16A18.16 18.16 0 0 1 43 90.84V61.16A18.16 18.16 0 0 1 61.16 43h29.68A18.16 18.16 0 0 1 109 61.16z"
                              data-original="#ffffff"
                            />
                            <path
                              d="m90.59 61.56-.19-.19-.16-.16A20.16 20.16 0 0 0 76 55.33 20.52 20.52 0 0 0 55.62 76a20.75 20.75 0 0 0 6 14.61 20.19 20.19 0 0 0 14.42 6 20.73 20.73 0 0 0 14.55-35.05zM76 89.56A13.56 13.56 0 1 1 89.37 76 13.46 13.46 0 0 1 76 89.56zm26.43-35.18a4.88 4.88 0 0 1-4.85 4.92 4.81 4.81 0 0 1-3.42-1.43 4.93 4.93 0 0 1 3.43-8.39 4.82 4.82 0 0 1 3.09 1.12l.1.1a3.05 3.05 0 0 1 .44.44l.11.12a4.92 4.92 0 0 1 1.1 3.12z"
                              data-original="#ffffff"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="https://t.me/enatgames">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-7 h-7"
                      viewBox="0 0 512 512"
                    >
                      <circle cx="256" cy="256" r="256" fill="#229ED9"></circle>

                      <path
                        fill="#ffffff"
                        d="M380.9 97.1 86.2 211.6c-12.6 5.1-12.5 22.9.2 27.7l75.4 23.5 29.1 93.3c3.6 11.7 18.1 15.9 27.6 8l41.7-34.1 80.3 58.8c9.8 7.2 23.8 1.8 26.2-10.3l51.8-259.7c2.6-13.2-10.2-23.7-22.6-18.7zM213.6 318.7l-18.2-58.4 125.9-96.1c5.6-4.3 11.4 3.4 6.6 8.7l-103.3 114.7-11 31.1z"
                      />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResponsiveMenu;
